import React from "react";
import { Box } from "@mui/material";
import tokens from "../../../shared/theme/tokens";

export type ContentSize = "narrow" | "default" | "wide";

const WIDTHS: Record<ContentSize, number> = {
  narrow: tokens.layout.contentNarrow,
  default: tokens.layout.contentDefault,
  wide: tokens.layout.contentWide,
};

/**
 * Content width constraint inside the AppShell. Replaces the legacy
 * WrpperAuthorizedContainer 600px cap: forms/settings use `narrow`,
 * card layouts `default`, tables/grids `wide`.
 */
export const ContentContainer = ({
  size = "default",
  sx,
  children,
}: {
  size?: ContentSize;
  sx?: object;
  children: React.ReactNode;
}) => (
  <Box
    sx={{
      width: "100%",
      maxWidth: `${WIDTHS[size]}px`,
      mx: "auto",
      px: { xs: 2, md: 4 },
      py: { xs: 2, md: 3.5 },
      ...sx,
    }}
  >
    {children}
  </Box>
);
